<template>
  <main class="lp">
    <!-- Modal de Autenticação -->
    <v-dialog v-model="showAuthDialog" max-width="400px" persistent>
      <v-card>
        <v-card-title class="text-h6">
          Acesso Restrito
        </v-card-title>
        <v-card-text>
          <p class="mb-4">Digite a senha para acessar os dados dos confirmados:</p>
          <v-text-field
            v-model="senha"
            label="Senha"
            type="password"
            outlined
            :error="senhaIncorreta"
            :error-messages="senhaIncorreta ? 'Senha incorreta' : ''"
            @keyup.enter="verificarSenha"
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="voltarParaInicio">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="verificarSenha" :disabled="!senha">
            Entrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Conteúdo da página (só aparece após autenticação) -->
    <div v-if="autenticado" class="content-wrapper">
      <v-container style="background-color: transparent;">
        <div class="text-center mb-4">
          <h2 class="mb-3">Lista de Confirmados</h2>
          <v-btn
            color="info"
            @click="downloadExcel"
            :disabled="Confirmados.length === 0"
          >
            <v-icon left>mdi-download</v-icon>
            Download Excel
          </v-btn>
        </div>
        <v-data-table
          :headers="headers"
          :items="Confirmados"
          class="elevation-1"
          style="background-color: white;"
        >
        </v-data-table>
        <p class="mt-3 text-center">Total de confirmados: {{ Confirmados.length }}</p>
      </v-container>
    </div>
  </main>
</template>

<script>
import * as XLSX from 'xlsx';

const API_BASE = 'https://pmariante.pythonanywhere.com'
export default {
  name: 'VerConfirmados',
  data() {
    return {
      headers: [
        { text: 'Nome', value: 'nome' },
        { text: 'Email', value: 'email' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Data de Inscrição', value: 'dataInscricao' }
      ],
      Confirmados: [],
      showAuthDialog: true,
      autenticado: false,
      senha: '',
      senhaIncorreta: false,
      senhaCorreta: 'TATI2025'
    };
  },
  created() {
    // Não carrega os dados automaticamente, só após autenticação
  },
  methods: {
    verificarSenha() {
      console.log('Verificando senha:', this.senha);
      if (this.senha === this.senhaCorreta) {
        console.log('Senha correta! Autenticando...');
        this.autenticado = true;
        this.showAuthDialog = false;
        this.senhaIncorreta = false;
        this.verConfirmados();
      } else {
        console.log('Senha incorreta');
        this.senhaIncorreta = true;
        this.senha = '';
        setTimeout(() => {
          this.senhaIncorreta = false;
        }, 3000);
      }
    },
    voltarParaInicio() {
      this.$router.push('/');
    },
    verConfirmados () {
      this.$http.get(`${API_BASE}/confirmadosPalestra`)
        .then(response => {
          console.log('Resposta da API:', response.data);
          this.Confirmados = response.data.map(item => {
            const [nome, email, telefone, dataInscricao] = item.split(';');
            return { nome, email, telefone, dataInscricao: dataInscricao || 'Não informado' };
          });
          console.log('Confirmados processados:', this.Confirmados);
        })
        .catch(err => {
          console.error('Erro ao ver confirmados:', err);
        })
    },
    downloadExcel() {
      if (this.Confirmados.length === 0) {
        alert('Não há dados para exportar');
        return;
      }

      // Preparar os dados para o Excel
      const data = this.Confirmados.map(item => ({
        'Nome': item.nome,
        'Email': item.email,
        'Telefone': item.telefone,
        'Data de Inscrição': item.dataInscricao
      }));

      // Criar o workbook e worksheet
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Confirmados Palestra');

      // Ajustar largura das colunas
      const wscols = [
        { wch: 30 }, // Nome
        { wch: 35 }, // Email
        { wch: 20 },  // Telefone,
        { wch: 25 }  // Data de Inscrição
      ];
      ws['!cols'] = wscols;

      // Gerar o nome do arquivo com data atual
      const hoje = new Date();
      const dataFormatada = hoje.toLocaleDateString('pt-BR').replace(/\//g, '-');
      const nomeArquivo = `confirmados_palestra_${dataFormatada}.xlsx`;

      // Fazer o download
      XLSX.writeFile(wb, nomeArquivo);
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
.montserrat-100 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 100;
  font-style: normal;
}
.montserrat-200 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 200;
  font-style: normal;
}
.montserrat-300 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 300;
  font-style: normal;
}
.montserrat-400 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}
.montserrat-500 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}
.montserrat-600 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
}
.montserrat-700 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
}
.montserrat-800 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 800;
  font-style: normal;
}
.montserrat-900 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 900;
  font-style: normal;
}

/* Reset e base */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #d3d3d3;
  font-family: 'Montserrat', sans-serif;
}

.lp {
  width: 100%;
  min-height: 100vh;
  font-family: 'Montserrat', sans-serif;
  background-color: #d3d3d3;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

.content-wrapper {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.v-data-table {
  background-color: white !important;
}

.v-container {
  background-color: transparent !important;
  width: 100%;
  max-width: none;
}

.v-btn {
  margin-bottom: 16px;
}

</style>